import { render } from "./NotificacoesCard.vue?vue&type=template&id=70ebbde5&scoped=true"
import script from "./NotificacoesCard.vue?vue&type=script&lang=js"
export * from "./NotificacoesCard.vue?vue&type=script&lang=js"

import "./NotificacoesCard.vue?vue&type=style&index=0&id=70ebbde5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ebbde5"]])

export default __exports__